enum AddressFormat {
    Street = 0,
    CityState = 1,
    StreetCityState = 2,
    Complete = 3
}

export default AddressFormat
